import {Component} from '@angular/core';
import {RouterLink} from "@angular/router";

import {appRoutes} from "@numizmat/constants";

@Component({
    selector: 'nz-help-password-reset',
    imports: [
        RouterLink
    ],
    templateUrl: './help-password-reset.component.html',
    styleUrl: './help-password-reset.component.scss'
})
export class HelpPasswordResetComponent {
  protected readonly appRoutes = appRoutes;
}
